export const stateRates = [
  { state: 'AK', rate: '$52' },
  { state: 'AL', rate: '$42' },
  { state: 'AR', rate: '$51' },
  { state: 'AZ', rate: '$46' },
  { state: 'CA', rate: '$60' },
  { state: 'CO', rate: '$42' },
  { state: 'CT', rate: '$62' },
  { state: 'DC', rate: '$67' },
  { state: 'DE', rate: '$44' },
  { state: 'FL', rate: '$45' },
  { state: 'GA', rate: '$54' },
  { state: 'HI', rate: '$52' },
  { state: 'IA', rate: '$51' },
  { state: 'ID', rate: '$52' },
  { state: 'IL', rate: '$50' },
  { state: 'IN', rate: '$48' },
  { state: 'KS', rate: '$47' },
  { state: 'KY', rate: '$43' },
  { state: 'LA', rate: '$46' },
  { state: 'MA', rate: '$59' },
  { state: 'MD', rate: '$54' },
  { state: 'ME', rate: '$54' },
  { state: 'MI', rate: '$46' },
  { state: 'MN', rate: '$55' },
  { state: 'MO', rate: '$50' },
  { state: 'MS', rate: '$38' },
  { state: 'MT', rate: '$55' },
  { state: 'NC', rate: '$45' },
  { state: 'ND', rate: '$52' },
  { state: 'NE', rate: '$50' },
  { state: 'NH', rate: '$50' },
  { state: 'NJ', rate: '$51' },
  { state: 'NM', rate: '$52' },
  { state: 'NV', rate: '$49' },
  { state: 'NY', rate: '$66' },
  { state: 'OH', rate: '$51' },
  { state: 'OK', rate: '$40' },
  { state: 'OR', rate: '$46' },
  { state: 'PA', rate: '$53' },
  { state: 'RI', rate: '$61' },
  { state: 'SC', rate: '$56' },
  { state: 'SD', rate: '$60' },
  { state: 'TN', rate: '$43' },
  { state: 'TX', rate: '$42' },
  { state: 'UT', rate: '$45' },
  { state: 'VA', rate: '$50' },
  { state: 'VT', rate: '$49' },
  { state: 'WA', rate: '$51' },
  { state: 'WI', rate: '$51' },
  { state: 'WV', rate: '$57' },
  { state: 'WY', rate: '$52' },
];